import service from "@/utils/request";

// 教材科目列表
export const getBookSubjectListApi = () => {
  return service({
    url: "/api/v1/book/subject_list",
    method: "get",
  });
};
// 教材分类列表
export const getBookCategoryListApi = () => {
  return service({
    url: "/api/v1/book/category_list",
    method: "get",
  });
};
// 教材选择列表
export interface bookSelectListData {
  page?: number;
  page_size?: number;
  book_title?: string;
  subject_id?: number;
  category_id?: number;
}
export const bookSelectListApi = (params: bookSelectListData) => {
  return service({
    url: "/api/v1/book/select_list",
    method: "get",
    params,
  });
};
// 员工教材选择列表
export interface staffBookSelectListData {
  page?: number;
  page_size?: number;
  book_title?: string;
  subject_id?: number;
  category_id?: number;
}
export const staffBookSelectListApi = (params: staffBookSelectListData) => {
  return service({
    url: "/api/v1/book/staff_select_list",
    method: "get",
    params,
  });
};
